export default __webpack_public_path__ + "static/tb_radler_04_EN-0a8058dcb53fdbcfdf92af79df76c979.svg";